<template>
  <!-- Search Filter -->
  <div
    class="row filter-row mb-4"
    v-if="hasEditPermission || $route.name == 'export-attendance'"
  >
    <!--
    <div class="col-sm-6 col-md-4">
      <div class="input-block mb-3 form-focus" :class="{ focused: isFocused }">
        <input
          class="form-control floating"
          v-model="employee_id"
          @focus="isFocused = true"
          @blur="isFocused = employee !== ''"
          type="text"
          @keyup.enter="filterData"
        />
        <label class="focus-label">Employee</label>
      </div>
    </div> -->
    <template v-if="hasEditPermission">
      <div class="col-sm-6 col-md-3">
        <div class="input-block mb-3 form-focus focused">
          <vue-select
            :options="employee_list"
            id="projectreportname"
            v-model="employee_id"
            placeholder="-"
          />
          <label class="focus-label">Employee Name</label>
        </div>
      </div>

      <div class="col-sm-6 col-md-3">
        <div class="input-block mb-3 form-focus select-focus">
          <div class="h-100">
            <a-select
              v-model:value="value"
              show-search
              placeholder="Select a Department"
              style="width: 100%"
              :options="optionsEmpDepartment"
              @change="handleChange"
            >
            </a-select>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-3">
        <div class="input-block mb-3 form-focus">
          <div class="h-100">
            <a-select
              v-model:value="employee_status"
              show-search
              placeholder="Employee Status"
              style="width: 100%"
              :options="empStatus"
              @change="handleEmpStatusChange"
            >
            </a-select>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-3">
        <div class="input-block mb-3 form-focus">
          <div class="h-100">
            <a-select
              v-model:value="termination_status"
              show-search
              placeholder="Terminated/Working"
              style="width: 100%"
              :options="terminationStatus"
              @change="handleTerminatedStatusChange"
            >
            </a-select>
          </div>
        </div>
      </div>
    </template>
    <div class="col-sm-6 col-md-4">
      <div class="input-block mb-3 form-focus">
        <div class="cal-icon">
          <datepicker
            v-model="start_date"
            :placeholder="
              $route.name == 'export-attendance' ? 'Start Date' : 'Joining From'
            "
            class="form-control floating datetimepicker"
            :editable="true"
            :clearable="false"
            :input-format="dateFormat"
          />
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-md-4">
      <div class="input-block mb-3 form-focus">
        <div class="cal-icon">
          <datepicker
            v-model="end_date"
            :placeholder="
              $route.name == 'export-attendance' ? 'End Date' : 'Joining To'
            "
            class="form-control floating datetimepicker"
            :editable="true"
            :clearable="false"
            :input-format="dateFormat"
          />
        </div>
      </div>
    </div>

    <div class="col-sm-6 col-md-2">
      <div class="d-grid">
        <a href="javascript:;" class="btn btn-success mb-3" @click="filterData">
          Search
        </a>
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="d-grid">
        <a href="javascript:;" class="btn btn-danger" @click="clearData">
          Clear
        </a>
      </div>
    </div>
  </div>
  <!-- /Search Filter -->
</template>
<script>
import { ref } from "vue";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
import axios from "axios";
import { notification } from "ant-design-vue";
import moment from "moment";
export default {
  emits: ["filter-data"],
  props: {
    hasEmployeeStatus: {
      type: [Boolean],
      required: false,
      default: () => false,
    },
    hasEditPermission: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      employee_list: [],
      select2: null,
      employeereportdepartment: [
        "Select Department",
        "Designing",
        "Development",
        "Finance",
        "Hr & Finance",
      ],
      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      startdateone: currentDateOne,
      employee: "",
      isFocused: false,
      departments: [],
      optionsEmpDepartment: [],
      value: null,
      department_id: null,
      employee_status: "",
      termination_status: "",
      employee_id: null,
      start_date: null,
      end_date: null,
      empStatus: [
        {
          label: "Employee Status",
          value: "",
        },
        {
          label: "Active",
          value: "1",
        },
        {
          label: "In Active",
          value: "0",
        },
      ],
      terminationStatus: [
        {
          label: "Employee Working/Terminated",
          value: "",
        },
        {
          label: "Working/Active",
          value: "1",
        },
        {
          label: "Terminated/Left",
          value: "0",
        },
      ],
    };
  },
  methods: {
    handleChange(value) {
      this.$nextTick(() => {
        this.department_id = value;
        this.filterData();
      });
    },
    handleEmpStatusChange(value) {
      this.$nextTick(() => {
        this.employee_status = value;
        this.filterData();
      });
    },
    handleTerminatedStatusChange(value) {
      this.$nextTick(() => {
        this.termination_status = value;
        this.filterData();
      });
    },
    filterData() {
      let search_filter = {
        department_id: this.department_id || null,
        employee_id: this.employee_id || null,
        start_date: this.start_date
          ? moment(this.start_date).format("YYYY-MM-DD")
          : null,
        end_date: this.end_date
          ? moment(this.end_date).format("YYYY-MM-DD")
          : null,
        employee_status:
          this.employee_status != "" ? this.employee_status : null,
        termination_status:
          this.termination_status != "" ? this.termination_status : null,
      };
      this.$emit("filter-data", search_filter);
    },
    clearData() {
      this.value = null;
      this.employee_id = null;
      this.start_date = null;
      this.end_date = null;
      this.employee_status = null;
      this.termination_status = null;

      let search_filter = {
        department_id: null,
        employee_id: null,
        start_date: null,
        end_date: null,
        employee_status: null,
        termination_status: null,
      };
      this.$emit("filter-data", search_filter);
    },
    loadAllEmployees(params) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      axios
        .get("/employees/allemployees", params)
        .then((response) => {
          //	console.log(response.data.data.data);

          //this.employee_list = response.data.data;

          console.log(response.data.data);

          for (let i = 0; i < response.data.data.length; i++) {
            this.employee_list.push({
              id: response.data.data[i].id,
              text:
                response.data.data[i].first_name +
                " " +
                response.data.data[i].last_name,
            });
          }
        })
        .catch((error) => {
          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
  },
  mounted() {
    var token = window.localStorage.getItem("token");
    axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios
      .get("departments/all")
      .then((response) => {
        if (response?.data?.data && response?.data?.data?.length) {
          const placeholder = [{ id: "", name: "All" }];
          this.departments = [...placeholder, ...response?.data?.data];
        } else {
          this.departments = [{ id: "", name: "No Records" }];
        }

        this.optionsEmpDepartment = this.departments.map((department) => {
          return {
            label: department.name,
            value: department.id,
          };
        });
      })
      .catch((error) => {
        if (
          error.response.status == 401 &&
          response.data.message == "Unauthenticated."
        ) {
          localStorage.clear();

          notification.open({
            message: "Please Login",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_WARNING_COLOR,
            },
          });

          this.$router.push({ name: "login" }).catch((error) => {});
        } else {
          this.errorMessage = error.message;
          notification.open({
            message: response.data.message,
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_WARNING_COLOR,
            },
          });
        }
      });

    this.loadAllEmployees([]);
  },
};
</script>
